"use client";
// Imports
import { Img } from "@/components";
import { useMediaQuery } from "@/hooks/use-media-query";
import Link from "next/link";
import { useState, useEffect } from "react";
import { sendGTMEvent } from "@next/third-parties/google";
import { resolveLink } from "@/lib/utils";

const desktop = "(min-width: 1850px)";
const headerSpacing = 24;

// Vertical Advertisement
export function VerticalAdvertisement({ type, ads }) {
  const isDesktop = useMediaQuery(desktop);
  const [ad, setAd] = useState(null);
  const [adTop, setAdTop] = useState(null);

  useEffect(() => {
    setAd(ads[Math.floor(Math.random() * ads.length)]);
  }, []);

  useEffect(() => {
    const header = document.querySelector("header");
    if (!header) return;

    const updateAdTop = () => {
      setAdTop(Math.ceil(header.getBoundingClientRect().height) + headerSpacing);
    };

    updateAdTop();

    const resizeObserver = new ResizeObserver(updateAdTop);
    resizeObserver.observe(header);

    return () => resizeObserver.disconnect();
  }, []);

  // if is not desktop, return null
  if (!isDesktop) return null;

  // if no ad yet / missing assets, return null
  if (!ad || adTop === null) return null;
  if (ad.skyscraper_desktop === null && ad.skyscraper_mobile === null) {
    return null;
  }

  function triggerGTMEvent() {
    sendGTMEvent("event", "clickedAdvertisement", {
      value: ad.title,
    });
  }

  // Render
  return (
    <div
      className="fixed inset-x-10 bottom-10 z-[999] min-h-[800px] flex items-start justify-center pointer-events-none"
      style={{ top: adTop }}
    >
      <div className="flex items-start justify-between w-full h-full">
        {[0, 1].map((side) => (
          <div
            key={side}
            className="pointer-events-auto flex w-[160px] flex-col items-center"
          >
            <Link
              target="_blank"
              data-ad={ad?.title}
              href={resolveLink(ad?.link) ?? "#"}
              className="relative block h-[600px] w-full"
              onClick={triggerGTMEvent}
            >
              <Img
                className="object-contain"
                data={ad?.skyscraper_desktop}
                fill
                sizes="160px"
              />
            </Link>
            <p className="pt-3 font-body text-xs text-center text-brand-espresso/70">
              Advertisement
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
